const initialState = {
    
    currentLanguage: "us"
    
}
export default(state=initialState, action) =>{
    
    switch(action.type){
        case "CHANGE_LANGUAGE":
            return{
                ...state,currentLanguage: action.payload
            }
    }
    return state
}